const namespaced = true;

const defaultState = () => {
  return {
    loading: false,
    operationReports: [],
    search: "",
    companyFilter: {},
    location_id: [],
    status: null,
    statusList: [
      {
        name: "Working",
        val: "working",
      },
      {
        name: "Finished",
        val: "finished",
      },
      {
        name: "Failed",
        val: "failed",
      },
    ],
    type: null,
    types: [
      { name: "Workload", value: "workload" },
      { name: "Rmt", value: "rmt" },
      { name: "Available Calculator", value: "availabe_calculator" },
    ],
    locations: [],
    page: 0,
    lastPage: 2,
    filter: false,
    per: 20,
    add: false,
    remove: false,
    selectedReportForRemove: null,
    selectedLocations: [],
  };
};

const state = defaultState();
const actions = {};
const mutations = {
  SET_REMOVE_REPORT(state, id) {
    const index = state.operationReports.findIndex((item) => item.id === id);
    state.operationReports.splice(index, 1);
  },
  SET_SELECTED_REPORT(state, selectedReportForRemove) {
    state.selectedReportForRemove = selectedReportForRemove;
  },
  SET_FILTER(state, filter) {
    state.filter = filter;
  },
  SET_REMOVE(state, remove) {
    state.remove = remove;
  },
  ADD_REPORT(state, val) {
    state.operationReports = [...state.operationReports, val];
  },
  SET_SELECTED_LOCATIONS(state, selectedLocations) {
    state.selectedLocations = selectedLocations;
  },
  REMOVE_LOCATION_ID(state, index) {
    state.location_id.splice(index, 1);
  },
  SET_LOCATIONS(state, locations) {
    state.locations = locations;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ADD(state, add) {
    state.add = add;
  },
  REPORT_PUSHER(state, operationReports) {
    for (const iterator of operationReports) {
      state.operationReports = [...state.operationReports, iterator];
    }
  },
  resetState(state) {
    Object.assign(state, defaultState());
  },
  SET_SEARCH(state, search) {
    state.search = search;
  },
  SET_TYPE(state, type) {
    state.type = type;
  },
  SET_LOCATION_ID(state, location_id) {
    state.location_id = location_id;
  },
  SET_STATUS(state, status) {
    state.status = status;
  },
  SET_REPORTS(state, operationReports) {
    state.operationReports = operationReports;
  },
  SET_PAGE(state, page) {
    state.page = page;
  },
  SET_LAST_PAGE(state, lastPage) {
    state.lastPage = lastPage;
  },
  SET_COMPANY_FILTER(state, companyFilter) {
    state.companyFilter = companyFilter;
  },
};
const getters = {};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
